<template>
  <div class="column is-12 is-paddingless">
    <div class="card card-user">
      <div
        class="accordion-title"
        :class="{'active': showInfo}"
        @click="togglePlayerInfo"
      >
        Welcome, {{ fullName }}
      </div>
      <div
        v-if="showInfo"
        class="card-content is-flex"
      >
        <div class="card-avatar card-avatar-current">
          <img :src="avatar">
          <div class="file is-boxed">
            <label class="file-label">
              <input
                ref="profile"
                class="file-input"
                type="file"
                name="resume"
                @change="uploadImage"
              >
              <i class="far fa-camera" />
              <small class="is-size-7">Update Picture</small>
            </label>
          </div>
        </div>

        <div class="link-current has-text-right">
          <div>
            <router-link
              to="/my-points"
              class="has-text-info"
            >
              My Points
            </router-link>
          </div>
          <div>
            <router-link
              to="/my-messages"
              class="has-text-info"
              :class="{badge}"
              :data-badge="badge"
            >
              My Messages
            </router-link>
          </div>
          <div>
            <router-link
                to="/mybonuses"
                class="has-text-info"
            >
              My Bonuses
            </router-link>
          </div>
          <div>
            <router-link
              to="/account-edit"
              class="has-text-info"
            >
              Settings
            </router-link>
          </div>
          <a
            class="button is-light is-small"
            @click="logout()"
          >
            <span>Logout</span>
            <span class="icon is-small">
              <i class="material-icons">power_settings_new</i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'CurrentUserInfo',
  props: ['user', 'token', 'badge'],
  data () {
    return {
      showInfo: true
    }
  },
  computed: {
    fullName () {
      return `${this.user.first} ${this.user.middle}. ${this.user.last}`
    },
    avatar () {
      if (this.user) {
        if (this.user.memberphoto === null) {
          return '/images/profile.png'
        }
        return this.user.memberphoto
      }
    }
  },
  methods: {
    uploadImage (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let file = files[0]
      let formData = new FormData()
      formData.append('file', file)
      axios.post(`member/profilepic/${this.token}`, formData, {
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
        }
      })
        .then((res) => {
          console.log('Image has been uploaded')
          this.$emit('updateProfilePicture')
        })
    },
    logout () {
      this.$emit('logout')
    },
    togglePlayerInfo () {
      this.showInfo = !this.showInfo
    }
  }
}
</script>
